import { render, staticRenderFns } from "./FacilityRecordDialog.vue?vue&type=template&id=492aafa4&scoped=true&"
import script from "./FacilityRecordDialog.vue?vue&type=script&lang=js&"
export * from "./FacilityRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492aafa4",
  null
  
)

export default component.exports